const initialState={
	usuarios:[],
	estadoUsuario:0,
	usuarioSelected:{id:"",name:"",usuario:"",password:"",tipo:""},	
	newUsuario:{name:"",usuario:"",password:"",tipo:"",codPais:""},
	userFilter:""	
};

export default function usuarioReducer(state= initialState,action){
	switch(action.type){
		case 'USUARIOS':
     		return {...state,usuarios:action.payload};
     	case 'USUARIO_SELECTED':
     		return {...state,usuarioSelected:action.payload};
     	case 'ESTADO_USUARIO':
     		return {...state,estadoUsuario:action.payload};    	
     	case 'NEW_USUARIO':
     		return { ...state, newUsuario: { ...state.newUsuario, ...action.payload } };
     	case 'USER_FILTER':
     		return { ...state, userFilter:action.payload};
     	default:
     		return state
	}
}

